import { allowedTypes as allowedTypesDragAndDrop } from '@components/drag-and-drop/src/drag-and-drop.type';
import { allowedTypes as allowedTypesInputFile } from '@components/input-file/src/input-file.types';

export const getAcceptedFormatForInputFile = ({
  acceptedFormat,
}: {
  acceptedFormat?: (typeof allowedTypesDragAndDrop | typeof allowedTypesInputFile)[number][] | [];
}) => {
  if (!acceptedFormat) return '';
  return acceptedFormat?.map((extension: string) => `.${extension}`).join(',');
};
